"use client"

import * as React from "react"

import NavMain from "./NavMain"

import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenuButton,
    SidebarRail,
    SidebarTrigger,
} from "@/components/shadcn/sidebar"

import {Link} from 'react-router-dom';
import { NavUser } from "./NavUser";
import { useSelector } from "react-redux";
import { data } from "./links";
export default React.memo(function AppSidebar() {
    const userProfileData = useSelector((state: any) => state.UserReducer.userProfileData);
    const role = userProfileData.role || null;

    const menuItems = React.useMemo(() => data(role), [role]);

    return (
        <Sidebar variant="sidebar" collapsible="icon" className="z-[55]">
            <div className="absolute left-0 z-0 flex justify-between w-full top-1.5">
                <div className="w-full" />
                <SidebarTrigger className="mt-2 -mr-10 bg-white rounded-full" />
            </div>

            <Link className="z-50" to="/">
                <SidebarHeader>
                    <SidebarMenuButton
                        size="lg"
                        className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground mx-auto h-full"
                    >
                        <img src="/sextant-logo.svg" alt="Sextant Logo" className="w-12 h-full" />
                        <div className="grid flex-1 text-sm leading-tight text-left">
                            <img src="/sextant-logo-text.svg" alt="Sextant Logo" className="h-6" />
                        </div>
                    </SidebarMenuButton>
                </SidebarHeader>
            </Link>

            <SidebarContent>
                <NavMain items={menuItems || []} />
            </SidebarContent>


            <SidebarFooter>
                <NavUser />
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
});
